import { Component, Input, OnInit } from '@angular/core';
import { WindowStatus } from 'src/app/enums/window-status.enum';
import { IWindowProcess } from 'src/app/interfaces/os/window-process.interface';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ShellService } from 'src/app/services/process/shell.service';
import { IconsService } from 'src/app/services/ux/icons.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-window-in-bar',
  templateUrl: './window-in-bar.component.html',
  styleUrls: ['./window-in-bar.component.scss']
})
export class WindowInBarComponent implements OnInit {
  @Input() window: IWindowProcess;

  private iconUrl: string;

  constructor(
    public theme: ThemeService,
    private windowMgr: WindowsManagerService,
    private shell: ShellService,
    private iconSv: IconsService) {
  }

  ngOnInit(): void {
    this.iconUrl = this.iconSv.getIcon(this.window.icon);
  }

  get hasIcon() {
    return this.iconUrl && this.iconUrl !== "";
  }

  get hasFocus(): boolean {
    return this.windowMgr.focused && this.windowMgr.focused.id === this.window.id;
  }

  get iconBackgroundStyle() {
    let style = "";

    if (this.iconUrl && this.iconUrl !== "") {
      style += `background-image: url(${this.iconUrl});`;
    }

    return style;
  }

  windowClick() {
    if (this.window.isMinimized()) {
      this.windowMgr.restoreWindowStatus(this.window.id);
    }
    else if (!this.hasFocus) {
      this.windowMgr.focus(this.window);
    }
    else {
      this.windowMgr.minimizeWindow(this.window.id);
    }
  }
}
